import clsx from "clsx"

import Skeleton from "@particles/Skeleton/Skeleton"

import styles from "./NoValueCell.module.scss"
import { NoValueCellProps } from "./NoValueCell.types"

export default function NoValueCell(props: NoValueCellProps) {
    const { isRightAligned, isLoading } = props

    if (isLoading) {
        return (
            <div
                className={clsx(styles.base, {
                    [styles.rightAligned]: isRightAligned,
                })}
            >
                <Skeleton width="100%" height={10} borderRadius={0} />
            </div>
        )
    } else {
        return (
            <div
                className={clsx(styles.base, {
                    [styles.rightAligned]: isRightAligned,
                })}
            >
                —
            </div>
        )
    }
}
